import FormattedMessage from 'I18n/components/FormattedMessage';
import UICardGrid from 'UIComponents/card/UICardGrid';
import { useSelector } from 'react-redux';
import { currentOrderedPaidProductLevels } from 'self-service-api/constants/ProductLevels';
import SplashPageCard from '../SplashPageCard';
import { STARTER, tabIdToProductLevels } from 'pricing-pages-ui/constants/routing/Tabs';
import { SPLASH_PAGE_CARD } from '../../../constants/tracking/Locations';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { isUngatedForMarketingPlusSelector } from '../../../selectors/GatingSelectors';
import { Container, Section, SectionHeader, SectionSubTitle, SectionTitle } from '../SplashPageSharedComponents';
import StarterCrmSuiteCard from './StarterCrmSuiteCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SuiteSection = ({
  selectedTab,
  sectionProps
}) => {
  const isAppAuth = useSelector(isAppAuthSelector);
  const isUngatedForMarketingPlus = useSelector(isUngatedForMarketingPlusSelector);
  const productLevelTiles = currentOrderedPaidProductLevels.map(productLevel => {
    const suiteTabFromProductLevel = Object.keys(tabIdToProductLevels).find(tabId => tabIdToProductLevels[tabId].includes(productLevel));
    return /*#__PURE__*/_jsx(SplashPageCard, {
      titleKey: `splash-page.bundles.${productLevel}.title`,
      descriptionKey: `splash-page.bundles.${productLevel}.description`,
      showIcon: false,
      pathname: isAppAuth ? '/suite' : `/suite/${suiteTabFromProductLevel}`,
      trackingSource: `${productLevel.toLowerCase()}-${SPLASH_PAGE_CARD}`
    }, productLevel);
  });
  return /*#__PURE__*/_jsx(Section, Object.assign({}, sectionProps, {
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(SectionHeader, {
        children: [/*#__PURE__*/_jsx(SectionTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `splash-page.bundles.title.${selectedTab}`
          })
        }), /*#__PURE__*/_jsx(SectionSubTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `splash-page.bundles.subtitle.${selectedTab}`
          })
        })]
      }), selectedTab === STARTER ? /*#__PURE__*/_jsx(StarterCrmSuiteCard, {}) : /*#__PURE__*/_jsxs(UICardGrid, {
        columnSize: isUngatedForMarketingPlus ? '25%' : '33%',
        children: [/*#__PURE__*/_jsx(_Fragment, {
          children: productLevelTiles
        }), isUngatedForMarketingPlus && /*#__PURE__*/_jsx(SplashPageCard, {
          titleKey: "splash-page.bundles.marketingPlus.title",
          descriptionKey: "splash-page.bundles.marketingPlus.description",
          showIcon: false,
          pathname: "/marketing-plus",
          trackingSource: `marketing-plus-${SPLASH_PAGE_CARD}`
        })]
      })]
    })
  }));
};
export default SuiteSection;